import { merge } from "lodash";

export const upsertOption = (obj, source) => merge({}, obj, source);
